import { render, staticRenderFns } from "./DashboardOverview.vue?vue&type=template&id=3cabacdd&scoped=true&"
import script from "./DashboardOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardOverview.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOverview.vue?vue&type=style&index=0&id=3cabacdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cabacdd",
  null
  
)

export default component.exports